<template>
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.667.045H9.333a4 4 0 00-4 4v23.91a4 4 0 004 4h13.334a4 4 0 004-4V4.044a4 4 0 00-4-4zm-4.667 30h-4a1.333 1.333 0 110-2.667h4a1.333 1.333 0 010 2.667zm4.667-4.667c.736 0 1.333-.597 1.333-1.333V6.712c0-.737-.597-1.334-1.333-1.334H9.333C8.598 5.378 8 5.975 8 6.712v17.333c0 .736.597 1.333 1.334 1.333h13.333z" fill="#fff"/></svg>
</template>

<script>
  export default {
    name: 'SocialIcon'
  }
</script>
